import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { getConsent, setConsent } from '../../utils/cookieConsent';

const BLUE = '#178ACB';
const FONT = 'Manrope, sans-serif';

// Modeled on the simpler Image Online reference (slim bottom bar, one line of
// text, single primary action) rather than a full Cookiebot-style panel with
// per-category toggles. GTM/gtag now load unconditionally from
// public/index.html regardless of this choice (see analyticsLoader.js) — this
// banner only records the visitor's preference for the privacy policy record.
const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setConsent('accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    setConsent('declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      role="region"
      aria-label="Cookie consent"
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1400,
        bgcolor: 'rgba(10, 14, 20, 0.92)',
        backdropFilter: 'blur(4px)',
        px: { xs: '16px', md: '32px' },
        py: { xs: '16px', md: '14px' },
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'stretch', md: 'center' },
        justifyContent: 'center',
        gap: { xs: '12px', md: '24px' },
      }}
    >
      <Typography
        sx={{
          fontFamily: FONT,
          fontSize: { xs: '12.5px', md: '13.5px' },
          color: 'rgba(255,255,255,0.88)',
          lineHeight: 1.6,
          maxWidth: '760px',
        }}
      >
        We use cookies to improve your experience and analyse site traffic.
        By clicking Accept, you agree to our use of cookies as described in our{' '}
        <Typography
          component={Link}
          to="/privacy-policy/"
          sx={{ color: BLUE, fontWeight: 600, textDecoration: 'underline', fontSize: 'inherit' }}
        >
          Privacy Policy
        </Typography>.
      </Typography>

      <Box sx={{ display: 'flex', gap: '10px', flexShrink: 0, justifyContent: 'flex-start' }}>
        <Button
          onClick={handleDecline}
          disableElevation
          sx={{
            fontFamily: FONT, fontSize: '13px', fontWeight: 700,
            color: 'rgba(255,255,255,0.85)', bgcolor: '#6B7280', textTransform: 'none',
            px: '20px', borderRadius: '6px', whiteSpace: 'nowrap',
            '&:hover': { bgcolor: '#5b6472' },
          }}
        >
          Decline
        </Button>
        <Button
          onClick={handleAccept}
          disableElevation
          sx={{
            fontFamily: FONT, fontSize: '13px', fontWeight: 700,
            color: 'white', bgcolor: BLUE, textTransform: 'none',
            px: '20px', borderRadius: '6px', whiteSpace: 'nowrap',
            '&:hover': { bgcolor: '#1270a8' },
          }}
        >
          Accept
        </Button>
      </Box>
    </Box>
  );
};

export default CookieConsentBanner;
